function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, JSON, Object) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['logo-img'] = function(metadata) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("img", {
          "attrs": __vjadeStringifyAttrsIfObj(metadata),
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'auth-footer': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`show-footer-links`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-footer-links': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("a", {
              "attrs": __vjadeStringifyAttrsIfObj({
                href: `/legal/terms-of-use/`,
                target: '_blank'
              }),
              "class": {
                'auth-footer-link': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Terms and Conditions");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("a", {
              "attrs": __vjadeStringifyAttrsIfObj({
                href: `/legal/privacy-policy/`,
                target: '_blank'
              }),
              "class": {
                'auth-footer-link': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Privacy Policy");;
              return __jade_nodes
            }).call(this).filter(Boolean))); /*  TODO: fix broken link */
            /*  a.auth-footer-link(attrs={href: `/resources/`, target: '_blank'}) Resources */
            __jade_nodes = __jade_nodes.concat("");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;